/* eslint-disable @typescript-eslint/no-explicit-any */
import alloy, { Init as AlloyInit } from '@alloyidentity/web-sdk';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlloyWrapper {
  public init(initParams: AlloyInit): Promise<any> {
    return alloy.init(initParams);
  }

  public open(callback: (data: any) => void, anchorElement?: string): void {
    alloy.open(callback, anchorElement);
  }

  public close(): void {
    alloy.close();
  }

  public createEvaluation(data: any): Promise<any> {
    return alloy.createEvaluation(data);
  }
}

export type Init = AlloyInit;
